import { lazy } from "react";
import { PermissionGuard, PermissionEnum } from "@/modules/authentication";

const Users = lazy(() => import("./Users"));
const Roles = lazy(() => import("./Roles"));
const Profile = lazy(() => import("./Profile"));
const SettingsLayout = lazy(() => import("../layouts"));

const Routes = () => {
	const baseUrl = "/settings";

	return [
		{
			path: baseUrl,
			element: (
				<PermissionGuard permission={PermissionEnum.RbacRead}>
					<SettingsLayout />
				</PermissionGuard>
			),
			children: [
				{
					path: `${baseUrl}`,
					element: <Profile />,
				},
				{
					path: `${baseUrl}/users`,
					element: (
						<PermissionGuard permission={PermissionEnum.RbacRead}>
							<Users />
						</PermissionGuard>
					),
				},
				{
					path: `${baseUrl}/roles`,
					element: (
						<PermissionGuard permission={PermissionEnum.RbacRead}>
							<Roles />
						</PermissionGuard>
					),
				},
			],
		},
	];
};

export { Routes };
